import React, { useState } from 'react';
import AILightComponent from '../../components/AILightComponent';
import SpeechInputComponent from '../../components/SpeechInputComponent';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMicrophone, faMicrochip, faDollarSign, faVoteYea } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';

const MOMForm = () => {
  // State hooks
  const [title, setTitle] = useState('');
  const [momTitle, setMomTitle] = useState('');
  const [momType, setMOMType] = useState('Type');
  const [heldOnDate, setHeldOnDate] = useState(new Date());
  const [locationAddress, setLocationAddress] = useState('');
  const [momCommittee, setMomCommittee] = useState('');

  const [momInvitees, setMomInvitees] = useState('');
  const [momPresents, setMomPresents] = useState('');
  const [momExcuses, setMomExcuses] = useState('');
  const [momProceedings, setMomProceedings] = useState('');
  const [momAgenda, setMomAgenda] = useState('');
  const [momChairman, setMomChairman] = useState('');
  const [momConvenor, setMomConvenor] = useState('');
  const [userCommentDetails, setUserCommentDetails] = useState('');
  const [isCheckedAISupport, setIsCheckedAISupport] = useState(false);
  const [showMicrophoneAlert, setShowMicrophoneAlert] = useState(false);
  const [isConversationalMOM, setIsConversationalMOM] = useState(false);
  const [showVoting, setShowVoting] = useState(false);


  const handleConversationalMOMCheckboxChange = (e) => {
    setIsConversationalMOM(e.target.checked);
  };

  const handleDone = () => {
    // Implement your handling logic here
  };

  const renderAIComponent = (param1, param2) => {
    return isCheckedAISupport && param2 !== '' && (
      <div className="ml-4 mr-4 mb-2 text-black">
        <AILightComponent param1={param1} param2={param2} />
      </div>
    );
  };

  return (
    <div className="p-4 text-sm bg-white text-blue-800">
      <div className="mb-8">
        <div className="flex flex-col mb-6 p-6 bg-gradient-to-r from-purple-200 via-blue-100 to-purple-300 rounded-lg shadow-lg">
          <h3 className="text-2xl font-bold mb-4 text-purple-700">MOM Details</h3>
          
          <p className="text-lg font-semibold mb-4 text-orange-700">
            Powered by: <span className="text-blue-800">Meetings.Chronicles@Think5Whys.com</span>
          </p>

          <p className="text-lg font-medium mb-4 text-gray-800">
            Make your meetings more conversational, data-centric, and democratic with features like:
          </p>

          <ul className="list-disc list-inside pl-4 mb-4">
            <li className="mb-2">Voice Input instead of typing</li>
            <li className="mb-2">Record Conversation and text input</li>
            <li className="mb-2">Take help of AI to standardize captured information</li>
            <li className="mb-2">Enable Silent Voting</li>
            <li className="mb-2">Enable Voice Vote</li>
            <li className="mb-2">Create PDF meeting reports</li>
            <li className="mb-2">View meeting History</li>
            <li className="mb-2">Listen to MOM instead of Reading</li>
            <li className="mb-2">Auto Translate in more than 30 languages</li>
          </ul>

          <p className="text-sm text-gray-700">
            <span className="font-semibold">Meetings.Chronicles@Think5Whys.com</span> - We Care For Humanity.<br />
            A meeting platform equally useful for visually challenged individuals & people who prefer not to write.
          </p>
        </div>
        <div className="flex flex-col mb-4">
          <label className="flex items-center text-blue-800">
            <input
              className="mr-4"
              type="checkbox"
              checked={isCheckedAISupport}
              onChange={() => setIsCheckedAISupport(!isCheckedAISupport)}
            />
            Gen AI Support (AI Prompt / Response from ChatGPT)
            <FontAwesomeIcon icon={faMicrochip} className="text-blue-800 text-lg ml-1" />
          </label>
        </div>

        <div className="flex flex-col mb-4">
          <label className="flex items-center text-blue-800">
            <input
              className="mr-4"
              type="checkbox"
              checked={showMicrophoneAlert}
              onChange={() => setShowMicrophoneAlert(!showMicrophoneAlert)}
            />
            Enable Voice Input
            <FontAwesomeIcon icon={faMicrophone} className="text-blue-800 text-lg ml-4" />
          </label>
        </div>

        {showMicrophoneAlert && (
          <label htmlFor="conversationalMOM" className="text-sm text-black ml-4 flex items-center">
            <input
              type="checkbox"
              id="conversationalMOM"
              checked={isConversationalMOM}
              onChange={handleConversationalMOMCheckboxChange}
              className="mr-2 text-blue-800"
            />
            Make it a Conversational MOM (Powered by Think5Whys AI Partners)
          </label>
        )}

        <div className="flex flex-col mb-4">
          <label className="flex items-center text-blue-800">
            <input
              className="mr-4"
              type="checkbox"
              checked={showVoting}
              onChange={() => setShowVoting(!showVoting)}
            />
            Enable Voting
            <FontAwesomeIcon icon={faVoteYea} className="text-blue-800 text-lg ml-4" />
          </label>
        </div>

        <div className="w-full flex flex-col bg-gray-200 text-black border-b border-b-gray-300 p-1">
          <p className="text-blue-800 ml-4">Type*:</p>
          <select
            name="momType"
            id="momType"
            value={momType}
            onChange={(e) => setMOMType(e.target.value)}
            className="ml-4"
            style={{ border: '1px solid #ccc', padding: '8px', height: '36px', width: '300px' }}
          >
            <option value="customerClientMeeting">Customer / Client Meeting</option>
            <option value="officeMeeting">Office Meeting</option>
            <option value="societyMeeting">Society Meeting</option>
            <option value="vendorSupplierMeeting">Vendor / Supplier Meeting</option>
            <option value="teamMeeting">Team Meeting</option>
            <option value="departmentalMeeting">Departmental Meeting</option>
            <option value="seminar">Seminar</option>
            <option value="personalOooMeeting">Personal O-O-O Meeting</option>
            <option value="businessMeeting">Business Meeting</option>
            <option value="otherMeeting">Other Meeting</option>
            <option value="socialMeeting">Social Meeting</option>
            <option value="trustsMeeting">Trusts Meeting</option>
            <option value="groupMeeting">Group Meeting</option>
          </select>

          <p className="text-blue-800 ml-4">Title*:</p>
          <input
            className="text-black ml-4 bg-slate-100 mb-2 w-full p-2"
            style={{ width: '100%' }}
            value={momTitle}
            onChange={(e) => setMomTitle(e.target.value)}
            placeholder="Input title"
          />
          {renderAIComponent(`Title: ${momTitle}`, userCommentDetails)}

          <p className="text-blue-800 ml-4">Opening Comment:</p>
          <textarea
            className="text-black ml-4 bg-white mb-2 w-full p-2"
            style={{ width: '100%', height: '200px' }}
            value={momAgenda}
            onChange={(e) => setMomAgenda(e.target.value)}
            placeholder="Input opening comment"
          />
          {renderAIComponent("Opening Comment", momAgenda)}

          <p className="text-blue-800 ml-4">MOM Committee:</p>
          <textarea
            className="text-black ml-4 bg-white mb-2 w-full p-2"
            style={{ width: '100%', height: '200px' }}
            value={momCommittee}
            onChange={(e) => setMomCommittee(e.target.value)}
            placeholder="Input MOM Committee"
          />
          {renderAIComponent("MOM Committee", momCommittee)}

          <p className="text-blue-800 ml-4">Held On*:</p>
          <input
            type="date"
            className="w-40 text-black ml-4 bg-slate-100 mb-2 p-2"
            value={heldOnDate.toISOString().split('T')[0]}
            onChange={(e) => setHeldOnDate(new Date(e.target.value))}
          />

          <p className="text-blue-800 ml-4">Held At*:</p>
          <textarea
            className="text-black ml-4 bg-white mb-2 w-full p-2"
            style={{ width: '100%', height: '200px' }}
            value={locationAddress}
            onChange={(e) => setLocationAddress(e.target.value)}
            placeholder="Input location"
          />
          {renderAIComponent("Held At", locationAddress)}

          <p className="text-blue-800 ml-4">Invitees:</p>
          <textarea
            className="text-black ml-4 bg-white mb-2 w-full p-2"
            style={{ width: '100%', height: '200px' }}
            value={momInvitees}
            onChange={(e) => setMomInvitees(e.target.value)}
            placeholder="Input invitees"
          />
          {renderAIComponent("Invitees", momInvitees)}

          <p className="text-blue-800 ml-4">Members Present:</p>
          <textarea
            className="text-black ml-4 bg-white mb-2 w-full p-2"
            style={{ width: '100%', height: '200px' }}
            value={momPresents}
            onChange={(e) => setMomPresents(e.target.value)}
            placeholder="Input members present"
          />
          {renderAIComponent("Members Present", momPresents)}

          <p className="text-blue-800 ml-4">Excuses:</p>
          <textarea
            className="text-black ml-4 bg-white mb-2 w-full p-2"
            style={{ width: '100%', height: '200px' }}
            value={momExcuses}
            onChange={(e) => setMomExcuses(e.target.value)}
            placeholder="Input excuses"
          />
          {renderAIComponent("Excuses", momExcuses)}

          <p className="ml-4">Proceedings:</p>
          <textarea
            className="text-black ml-4 bg-white mb-2 w-full p-2"
            style={{ width: '100%', height: '200px' }}
            value={momProceedings}
            onChange={(e) => setMomProceedings(e.target.value)}
            placeholder="Input proceedings"
          />
          {renderAIComponent("Proceedings", momProceedings)}

          <p className="text-blue-800 ml-4">Agenda:</p>
          <textarea
            className="text-black ml-4 bg-white mb-2 w-full p-2"
            style={{ width: '100%', height: '200px' }}
            value={momAgenda}
            onChange={(e) => setMomAgenda(e.target.value)}
            placeholder="Input agenda"
          />
          {renderAIComponent("Agenda", momAgenda)}

          <p className="text-blue-800 ml-4">Chairman:</p>
          <input
            className="text-black ml-4 bg-slate-100 mb-2 w-full p-2"
            style={{ width: '100%' }}
            value={momChairman}
            onChange={(e) => setMomChairman(e.target.value)}
            placeholder="Input chairman"
          />
          {renderAIComponent("Chairman", momChairman)}

          <p className="text-blue-800 ml-4">Convenor:</p>
          <input
            className="text-black ml-4 bg-slate-100 mb-2 w-full p-2"
            style={{ width: '100%' }}
            value={momConvenor}
            onChange={(e) => setMomConvenor(e.target.value)}
            placeholder="Input convenor"
          />
          {renderAIComponent("Convenor", momConvenor)}

          <p className="text-blue-800 ml-4">Additional Comments:</p>
          <textarea
            className="text-black ml-4 bg-white mb-2 w-full p-2"
            style={{ width: '100%', height: '200px' }}
            value={userCommentDetails}
            onChange={(e) => setUserCommentDetails(e.target.value)}
            placeholder="Input additional comments"
          />
          {renderAIComponent("Additional Comments", userCommentDetails)}
        </div>

        <div className="mt-4">
          <button
            type="button"
            onClick={handleDone}
            className="bg-blue-500 text-white px-4 py-2 rounded"
          >
            Done
          </button>
        </div>
      </div>
    </div>
  );
};

export default MOMForm;
